
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"


export default class extends Controller {
    static targets = ["example_select"];
  connect() {
    this.isRequesting = false
    console.log("Dropdown controller initialized!");
  }
  startRequest() {
    this.isRequesting = true
    this.showProgressBar()
  }
  // change(event) {
  //   const value = event.target.value;

  showProgressBar() {
    Turbo.navigator.adapter.progressBar.setValue(0) // Reset progress bar
    Turbo.navigator.adapter.progressBar.show()      // Show the progress bar
  }
  hideProgressBar() {
    Turbo.navigator.adapter.progressBar.hide()      // Hide the progress bar
  }

  async change(event) {
    const value = event.target.value;
    this.startRequest()
    // Only send the request if the value is selected
    if (value) {
      try {
        // Make a POST request using Fetch API
        const response = await fetch( '/vendor/fabricator', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content  // Ensure CSRF protection
          },
          body: JSON.stringify({ id: value })  // Send the selected value as JSON
        });

        if (response.ok) {
          // Get the updated HTML content from the response
          const updatedContent = await response.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = updatedContent;
          // Find the specific #table-change element in the response
          const newContent = tempDiv.querySelector('#table-change');
          if (newContent) {
            const oldContent = document.getElementById('table-change');
            oldContent.parentNode.replaceChild(newContent, oldContent);     
          } else {
            console.error('#table-change not found in the response.');
          }
          this.hideProgressBar() 
        } else {
          console.error('Failed to submit the form');
        }
      } catch (error) {
        this.hideProgressBar()
        console.error('Error during POST request:', error);
      }
    }
  }

}


